@if (router.url === '/orders') {
  <form (submit)="onFormSubmit($event)">
    <div class="search-box">
      @if (getIsSearchByCode()) {
        <div class="search-box__id">
          <dx-number-box
            format="#"
            [(value)]="filterOrderId"
            [showClearButton]="true"
            class="dx-number-box"
            placeholder="{{ 'FILTER_BY_SD_ORDER' | translate }}">
            <dx-validator>
              <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dx-validator>
          </dx-number-box>
        </div>
      }
      @if (getIsSearchByDate()) {
        <div class="search-box__date">
          <span class="d-none d-xl-inline-block">{{ 'FILTER_DATE_FROM' | translate }}</span>
          <dx-date-box [(value)]="filterDateFrom" type="date">
            <dx-validator>
              <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
              <dxi-validation-rule
                type="compare"
                [comparisonTarget]="toDate"
                comparisonType="<"
                message="{{ 'DATE_FROM_INCORECT_TO_DATE' | translate }}"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
          <span class="d-inline-block d-xl-none">
            <i class="mdi mdi-arrow-left-right-bold mdi-18px"></i>
          </span>
          <span class="d-none d-xl-inline-block">{{ 'FILTER_DATE_TO' | translate }}</span>
          <dx-date-box [(value)]="filterDateTo" type="date">
            <dx-validator>
              <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
              <dxi-validation-rule
                type="compare"
                [comparisonTarget]="fromDate"
                comparisonType=">"
                message="{{ 'DATE_TO_INCORECT_FROM_DATE' | translate }}"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </div>
      }
      <dx-button
        text="{{ 'SEARCH_ORDER' | translate }}"
        [useSubmitBehavior]="true"
        class="btn btn-small ml-lg-2"
        icon="mdi mdi-magnify"></dx-button>
      @if (getIsSearchByDate()) {
        <div class="search-box__switch">
          <div class="switch-box-holder">
            <div class="switch-box">
              <div (click)="setSearchByCode()">
                <i class="mdi mdi-close me-1 d-none d-xl-block"></i>
                {{ 'SEARCH_BY_CODE' | translate }}
              </div>
              <div class="switch-box__on">
                <i class="mdi mdi-check me-1 d-none d-xl-block"></i>
                {{ 'SEARCH_BY_DATE' | translate }}
              </div>
            </div>
          </div>
        </div>
      }
      @if (getIsSearchByCode()) {
        <div class="search-box__switch">
          <div class="switch-box-holder">
            <div class="switch-box">
              <div class="switch-box__on">
                <i class="mdi mdi-check me-1 d-none d-xl-block"></i>
                {{ 'SEARCH_BY_CODE' | translate }}
              </div>
              <div (click)="setSearchByDate()">
                <i class="mdi mdi-close me-1 d-none d-xl-block"></i>
                {{ 'SEARCH_BY_DATE' | translate }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </form>
}
